import script from "./WebAssistantImageUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebAssistantImageUpload.vue?vue&type=script&lang=ts&setup=true"

import "./WebAssistantImageUpload.vue?vue&type=style&index=0&id=2c2b4f76&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c2b4f76"]])

export default __exports__